module.exports = __webpack_public_path__ + "static/assets/aa5968e3e23ee8f6143e05525cdd4052.svg";